import React from "react";
import { IonInput, IonLabel, IonText, IonTextarea } from "@ionic/react";
import { Controller, FieldError } from "react-hook-form";
import { IControlData, IInputWrapperData } from "../../models/Control";
import classNames from "classnames";
import InputError from "../utils/InputError";
import InputHint from "../utils/InputHint";

interface IProps {
  name: string;
  label: string | null;
  error?: FieldError;
  hint?: string;
  controlData?: IControlData;
  inputData: IInputWrapperData;
  multiLine?: boolean;
}

const InputWrapper: React.FC<IProps> = ({ name, error, label, controlData, inputData, hint, multiLine = false }) => {
  return (
    <div className={classNames("ion-stack vertical", error ? "error" : "")}>
      {label && (
        <IonLabel>
          {label}
          {controlData?.rules?.required?.value === true ? <IonText color="danger">*</IonText> : null}
        </IonLabel>
      )}
      {controlData ? (
        <Controller
          name={name}
          render={({ field: { onChange, value } }) => (
            <>
              {multiLine ? (
                <IonTextarea onIonChange={(e: any) => onChange(e.detail.value!)} value={value} name={name} placeholder={inputData.placeholder ?? ""} autoGrow />
              ) : (
                <IonInput onIonChange={(e: any) => onChange(e.detail.value!)} value={value} name={name} clearOnEdit={false} {...inputData} />
              )}
            </>
          )}
          {...controlData}
        />
      ) : (
        <IonInput name={name} clearOnEdit={false} {...inputData} />
      )}
      {error ? <InputError>{error.message ?? ""}</InputError> : null}
      {hint ? <InputHint>{hint}</InputHint> : null}
    </div>
  );
};

export default InputWrapper;
